<template>
  <div class="form_con">
    <div class="fixed">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon
              name="arrow-left"
              class="mar_r"
              @click="goback"
              size="0.4rem"
            />
            <div class="search_con m_flex_box flex_vc">查看资质变更</div>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed_pad"></div>
    <van-form
      @submit="onSubmit"
      validate-trigger="onSubmit"
      :scroll-to-error="true"
    >
      <h5>授权委托书:(加盖公章的扫描件,jpg格式):</h5>
      <div class="pic_con">
        <img
          :src="submitObj.trustImg"
          alt=""
          class="small"
          v-if="submitObj.trustImg"
        />
        <img :src="seatImg" alt="" class="small" v-else />
      </div>
      <van-field
        readonly
        v-model="submitObj.corpName"
        name="enterpriseName"
        type="text"
        label="企业名称:"
        placeholder="请输入企业名称"
        maxlength="10"
      />
      <van-field
        readonly
        v-model="submitObj.corpNature"
        name="enterpriseName"
        type="text"
        label="企业性质:"
        maxlength="10"
      />
      <van-field
        readonly
        v-model="submitObj.corpGrade"
        name="enterpriseName"
        type="text"
        label="资质等级:"
        maxlength="10"
      />
      <!-- <van-field
      readonly
        v-model="submitObj.corpFund"
        name="注册金额"
        label="注册金额:"
        type="text"
        placeholder="请输入注册金额"
        maxlength="10"
      /> -->
      <van-field
        readonly
        v-model="submitObj.corpAddress"
        type="text"
        name="注册地址"
        label="注册地址:"
        placeholder="请输入注册地址"
      />
      <van-field
        readonly
        v-model="submitObj.certNo"
        name="certificateNumber"
        type="text"
        label="企业资质证书号:"
        placeholder="请输入资质证书"
        maxlength="30"
      />
      <h5>企业资质证书有效期</h5>
      <van-field
        readonly
        clickable
        name="picker"
        :value="submitObj.certStartDate"
        value-key="text"
        label="开始时间:"
        placeholder="点击选择时间"
      />
      <van-field
        readonly
        clickable
        name="picker"
        :value="submitObj.certLimitDate"
        value-key="text"
        label="结束时间(选填):"
        placeholder="-"
      />
      <h5>资质证书复印扫描件:(加盖公章,jpg格式)</h5>
      <div class="pic_con">
        <img
          :src="submitObj.certCopyImg"
          alt=""
          class="small"
          v-if="submitObj.certCopyImg"
        />
        <img :src="seatImg" alt="" class="small" v-else />
      </div>
      <h5>资质证书原件扫描件:(jpg)</h5>
      <div class="pic_con">
        <img
          :src="submitObj.certImg"
          alt=""
          class="small"
          v-if="submitObj.certImg"
        />
        <img :src="seatImg" alt="" class="small" v-else />
      </div>
      <van-cell-group>
        <van-field
          readonly
          v-model="submitObj.remark"
          rows="3"
          autosize
          label="备注(选填):"
          type="textarea"
          placeholder="请输入备注"
          maxlength="50"
          show-word-limit
        />
      </van-cell-group>
      <van-field v-model="submitObj.state" label="审核状态:" type="text" />
      <van-cell-group>
        <van-field
          readonly
          v-model="submitObj.rejectReason"
          rows="3"
          autosize
          label="未通过原因:"
          type="textarea"
          placeholder="无"
        />
      </van-cell-group>

      <div style="margin: 16px; padding-bottom: 16px">
        <van-button
          block
          type="info"
          @click="modifyApply"
          v-show="submitObj.process == 3"
          >修改申请</van-button
        >
        <van-button
          block
          type="info"
          @click="revokeApply"
          v-show="submitObj.process == 2"
          >撤销申请</van-button
        >
      </div>
    </van-form>
    <!-- <van-overlay
      :show="show"
      class="m_flex_box flex_hc flex_vc"
      @click="show = false"
    > -->
    <!-- <div class="wrap m_flex_box flex_vc flex_hc">
        <img src="@/assets/img/sfz_s.png" alt="" />
      </div>
    </van-overlay> -->
  </div>
</template>

<script>
let timmer = null;
import qs from "qs";
export default {
  data() {
    return {
      submitObj: {
        corpName: "", //企业名称
        corpNature: "", //企业性质
        corpGrade: "", //资质等级
        corpFund: "", //注册金额
        corpAddress: "", //地址
        legalImg: "", //法人身份证
        certStartDate: "", //资质开始日期
        certLimitDate: "", //资质结束日期
        certImg: "", //资质证书扫描件
        certCopyImg: "", //资质证书复印件
        process: "", //流程
        applyType: "0", //变更类型
        rejectReason: "", //驳回原因
        state: "", //审核状态
      },
      seatImg: require("@/assets/img/up.png"),
      seatFrontImg: require("@/assets/img/u1.png"),
      seatBackImg: require("@/assets/img/u2.png"),
      startMinDate: new Date(1970, 1, 1),
      startMaxDate: new Date(),
      endMinDate: new Date(),
      endMaxDate: new Date(2100, 1, 1),
      currentDate: new Date(),
      natureList: [],
      gradeList: [],
      natureRole: "", //企业性质
      natureId: "",
      gradeRole: "", //等级资质
      gradeId: "",
      licenseEndShow: false,
      licenseStartShow: false,
      naturePicker: false,
      gradePicker: false,
      certificateStartShow: false,
      certificateEndShow: false,
      applyId: this.$route.query.applyId,
    };
  },
  components: {},
  mounted() {
    this.infoInit();
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    modifyApply() {
      this.$router.replace({
        path: "/qualificationChange",
        query: { applyId: this.applyId },
      });
    },

    //撤销
    revokeApply() {
      // trustImg: this.submitObj.trustImg,
      //     licenseImg: this.submitObj.licenseImg,
      //     licenseCopyImg: this.submitObj.licenseCopyImg,
      //     legalImg: this.submitObj.legalImg,
      this.$test
        .post(
          "spf/corpinfoapply/update",
          qs.stringify({
            applyId: this.applyId,
            process: "1",
          }),
          {
            headers: {
              xzfpftoken: sessionStorage.getItem("userId") || "",
            },
          }
        )
        .then((res) => {
          this.$toast(res.msg);
          if (res.code == "000") {
            this.$router.go(-1)
            // this.$router.replace({
            //   path: "/myManagement",
            // });
          }
        });
    },

    //信息初始化
    infoInit() {
      this.$test
        .post(
          "spf/corpinfoapply/detail",
          qs.stringify({
            applyId: this.applyId,
          }),
          {
            headers: {
              xzfpftoken: sessionStorage.getItem("userId") || "",
            },
          }
        )
        .then((res) => {
          if (res.code == "000") {
            var newObj = Object.assign(res.result, {});
            if (newObj.process == 1) {
              newObj.state = "草稿";
            } else if (newObj.process == 2) {
              newObj.state = "未通过";
            } else if (newObj.process == 3) {
              newObj.state = "未通过";
            } else if (newObj.process == 4) {
              newObj.state = "已通过";
            } else {
              newObj.state = "已归档";
            }
            this.submitObj = newObj;
          }
        });
    },
    //保存草稿
    saveDraft() {
      this.submitObj.process = "1";
      this.$test
        .post("spf/corpinfoapply/add", qs.stringify(this.submitObj), {
          headers: {
            xzfpftoken: sessionStorage.getItem("userId") || "",
          },
        })
        .then((res) => {
          if (res.code == "000") {
            this.$router.replace({
              path: "/myManagement",
            });
          } else {
            this.$toast(res.msg);
          }
        });
    },
    // testPostcode(data) {
    //   return /^\d{6}$/.test(data);
    // },
    // testPhone(data) {
    //   return /^1[3456789]\d{9}$/.test(data);
    // },
    // testIdCard(data) {
    //   return /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/.test(
    //     data
    //   );
    // },

    //企业性质初始化
    natureInit() {
      this.$test
        .post(
          "spf/codeinfo/getListByCode",
          qs.stringify({
            code: "01",
          }),
          {
            headers: {
              xzfpftoken: sessionStorage.getItem("userId") || "",
            },
          }
        )
        .then((res) => {
          if (res.code == "000") {
            this.natureList = res.result;
          } else if (res.code == "003") {
            this.$toast(res.msg);
            this.$router.replace({
              path: "/enterpriseAccess",
            });
          } else {
            this.$toast(res.msg);
          }
        });
    },
    //资质等级初始化
    gradeInit() {
      this.$test
        .post(
          "spf/codeinfo/getListByCode",
          qs.stringify({
            code: "02",
          }),
          {
            headers: {
              xzfpftoken: sessionStorage.getItem("userId") || "",
            },
          }
        )
        .then((res) => {
          if (res.code == "000") {
            this.gradeList = res.result;
          } else {
            this.$toast(res.msg);
          }
        });
    },

    formatDateTime(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    },
    natureConfirm(value) {
      this.submitObj.corpNature = value.codeContent;
      // this.natureId = value.codeInfoId;
      this.naturePicker = false;
    },
    gradeConfirm(value) {
      this.submitObj.corpGrade = value.codeContent;
      // this.submitObj.corpGradevalue.codeInfoId
      // this.gradeId = value.codeInfoId;
      this.gradePicker = false;
    },
    certificateStartConfirm(value) {
      this.submitObj.certStartDate = this.formatDateTime(value);
      this.certificateStartShow = false;
    },
    certificateEndConfirm(value) {
      this.submitObj.certLimitDate = this.formatDateTime(value);
      this.certificateEndShow = false;
    },

    beforeRead(file) {
      if (
        file.type.toLowerCase() !== "image/jpg" &&
        file.type.toLowerCase() !== "image/jpeg"
      ) {
        this.$toast("该格式不支持");
        return false;
      } else if (file.size > 10000 * 1024) {
        this.$toast("文件大小不得超过5M");
        return false;
      }
      return true;
    },
    //法人身份证
    afterReadOne(file) {
      this.submitObj.legalImg = file.content;
    },
    //资质证书复印
    afterReadTwo(file) {
      this.submitObj.certCopyImg = file.content;
    },
    //资质证书原件
    afterReadThree(file) {
      this.submitObj.certImg = file.content;
    },
    //营业执照复印
    afterReadFour(file) {
      this.submitObj.licenseCopyImg = file.content;
    },
    //营业执照原件
    afterReadFive(file) {
      this.submitObj.licenseImg = file.content;
    },
    //操作员身份证正面
    afterReadSix(file) {
      this.submitObj.operaterFrontImg = file.content;
    },
    //操作员身份证反面
    afterReadSeven(file) {
      this.submitObj.operaterBackImg = file.content;
    },
    //操作员照片
    afterReadEight(file) {
      this.submitObj.operaterImg = file.content;
    },
    //入网申请书
    afterReadNine(file) {
      this.submitObj.applyImg = file.content;
    },
    //登记表
    afterReadTen(file) {
      this.submitObj.registerImg = file.content;
    },
    //入网委托书
    afterReadEleven(file) {
      this.submitObj.trustImg = file.content;
    },
  },
};
</script>
<style lang="less" scoped>
.fixed_pad {
  padding-top: 1.1rem;
}
.bg_gray {
  min-height: 100vh;
  background-color: #ffffff;
}
.fixed {
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  .top_normal {
    height: 100%;
    i {
      font-size: 0.32rem;
    }
  }
}
.top_header {
  height: 0.7rem;
  padding: 0.1rem 0rem;
  width: 7.04rem;
  margin: 0 auto;
  &.top_sm {
    padding: 0.1rem;
  }
  .search_con,
  .search_con_l {
    height: 0.7rem;
    box-sizing: border-box;
    font-size: 0.3rem;
    padding: 0 0.3rem;
    color: #303030;
    i {
      font-size: 0.36rem;
      margin-right: 0.2rem;
    }
  }
  input {
    width: 80%;
    height: 0.7rem;
    background-color: transparent;
  }
  .search_con {
    font-weight: bolder;
    justify-content: center;
    width: 5.78rem;
  }
  .search_con_l {
    width: 5.72rem;
  }
  .to_map {
    font-size: 0.28rem;
    img {
      margin-right: 0.06rem;
      width: 0.32rem;
      height: 0.32rem;
    }
  }
}
.form_con {
  // padding: 0.3rem 0rem;
  .saveDraft {
    padding: 0.1rem 0.15rem;
    font-size: 0.2rem;
    border-radius: 0.1rem;
    border: 1px solid #007fff;
    color: #007fff;
    position: absolute;
    right: 0.2rem;
    top: 50%;
    transform: translateY(-50%);
  }
  /deep/ .b_f {
    line-height: 32px;
  }
}
h5 {
  font-size: 14px;
  padding: 10px 16px 0;
  color: #646566;
}
.pic_con {
  padding: 16px 16px;
  position: relative;
  .small {
    width: 2.56rem;
    height: 1.63rem;
  }
  .big {
    width: 2.18rem;
    height: 3.4rem;
  }
  p {
    color: #474747;
    font-size: 12px;
    width: 2.56rem;
    text-align: center;
    margin-top: 0.1rem;
    color: #666;
  }
  &:after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 16px;
    bottom: 0;
    left: 16px;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}
.col_blue {
  color: #2f72f5;
  font-size: 0.26rem;
}
.wrap {
  background-color: #fff;
  width: 5.8rem;
  height: 7.84rem;
  border-radius: 0.02rem;
  img {
    width: 4.04rem;
    height: 6.28rem;
  }
}
</style>